import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box, Table, TableHead, TableRow, TableCell, TableBody,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {useFindStudentVirtualGroupMutation} from "../store/chair/chairApi";
import {Search} from "@mui/icons-material";
import copyObject from "../utils/copyObject";

export default function FindStudentVirtualGroupPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [dataRequest] = useFindStudentVirtualGroupMutation();
    const [patternObj, setPatternObj] = useState({
        pattern: '',
    });
    const [copyOfData, setCopyOfData] = useState([]);
    
    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        setIsLoading(true);

        await dataRequest({data: {pattern: patternObj.pattern}}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setCopyOfData(copyObject(fulfilled.data).sort((l,r) => l.fullName > r.fullName ? 1 : -1));
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
            alert('Ошибка');
        });
    };

    return (
        <GeneralLayout>
            <PageTitle title={`Поиск сводной группы студента`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Поиск сводной группы студента
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2} direction={'row'}>
                                <TextField size={'small'}
                                           fullWidth
                                           onChange={(event) => { patternObj.pattern = event.target.value }}
                                           placeholder={'ФИО студента'}/>
                                
                                <Button variant="contained"
                                        disabled={isLoading}
                                        size={'small'}
                                        startIcon={isLoading ? <CircularProgress size="1rem" /> : <Search />}
                                        onClick={handleSave}>Поиск</Button>
                            </Stack>
                        </CardContent>
                    </Card>

                    {copyOfData && copyOfData.length > 0
                    ?
                        <Card>
                            <Table size={'small'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>№</TableCell>
                                        <TableCell>ФИО</TableCell>
                                        <TableCell>Группа</TableCell>
                                        <TableCell>Сводная группа</TableCell>
                                        <TableCell>Преподаватель</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {copyOfData.map((item, index) => {
                                        return <TableRow>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{item.fullName}</TableCell>
                                            <TableCell>{item.groupName && item.groupName.length > 0 ? item.groupName : '-'}</TableCell>
                                            <TableCell>{item.virtualGroupName}</TableCell>
                                            <TableCell>{item.employeeName}</TableCell>
                                        </TableRow>
                                    })}
                                </TableBody>
                            </Table>
                        </Card>
                    : <></>}

                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}